import { Component, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'essent-commodity-offer-product-breakdown-row',
  templateUrl: './commodity-product-breakdown-row.component.html',
  styleUrls: ['./commodity-product-breakdown-row.component.essent.scss'],
  standalone: true,
  imports: [DefaultComponentModule, RoundedCurrencyPipe],
})
export class CommodityOfferEssentProductBreakdownRowComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public description?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public value!: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public prefix = '';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rowStyle: 'regular' | 'discount' = 'regular';

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public textStyle: 'regular' | 'bold' = 'regular';

  public get backgroundClass(): { [key: string]: boolean } {
    return {
      'commodity-offer-breakdown-cell--discount': this.rowStyle === 'discount',
      'bg-light': this.rowStyle === 'regular',
      'fw-bold': this.textStyle === 'bold',
    };
  }
}
